import {
  createView,
  observableValue,
  useSharedState,
  view,
  View,
} from '@esui/core';
import '@material/mwc-drawer';
import { html } from 'lit';

export const [Drawer] = view('esui-mwc-drawer', {
  Props: class {
    content: View[] = [];
    title: string | View = '';
    subtitle: string | View = '';
    header: string | View = '';
    appContent?: View = undefined;
    hasHeader = false;
    open = observableValue(false);
    dismissable = false;
    modal = false;
  },

  mapBuilder:
    DrawerBuilder =>
    (...content: (View | undefined)[]) =>
      DrawerBuilder().content(content.filter(el => el) as View[]),

  template(props) {
    const open = useSharedState(props.open);
    const {
      content,
      title,
      subtitle,
      appContent,
      hasHeader,
      header,
      dismissable,
      modal,
    } = props;

    const type = () => {
      if (dismissable) {
        return 'dismissible';
      }
      if (modal) {
        return 'modal';
      }
      return '';
    };

    function handleClosed() {
      open.value = false;
    }

    return html`
      <mwc-drawer
        ?hasHeader="${hasHeader}"
        ?open="${open.value}"
        type="${type()}"
        @MDCDrawer:closed="${handleClosed}"
      >
        ${content.map(el => el.body)} ${DrawerTitle(title)?.body}
        ${DrawerSubTitle(subtitle)?.body} ${DrawerHeader(header)?.body}
        ${appContent && AppContent(appContent).body}
      </mwc-drawer>
    `;
  },
});

function Title(title: string | View, slot: string) {
  if (title) {
    if (typeof title === 'string') {
      return createView(html`<span slot="${slot}">${title}</span>`);
    }
    return title.slot(slot);
  }
}

export function DrawerTitle(title: string | View) {
  return Title(title, 'title');
}

export function DrawerSubTitle(subtitle: string | View) {
  return Title(subtitle, 'subtitle');
}

export function DrawerHeader(header: string | View) {
  return Title(header, 'header');
}

export function AppContent(content: View) {
  return createView(html` <div slot="appContent">${content.body}</div>`);
}
